import React, { Component } from "react";
import { connectCurrentRefinements } from "react-instantsearch-dom";
import PropTypes from "prop-types";

class Reset extends Component {
    static propTypes = {
        linkText: PropTypes.string,
        refine: PropTypes.func.isRequired,
        items: PropTypes.array
    };

    handleClick = () => {
        const { refine, items } = this.props;

        refine(items);
    };

    render() {
        const { linkText } = this.props;

        return <a onClick={this.handleClick}>{linkText}</a>;
    }
}

export default connectCurrentRefinements(Reset);



// WEBPACK FOOTER //
// ./public/assets/scripts/components/products/Reset.js